// extracted by mini-css-extract-plugin
export default {"content":"components-hotel-account-selection-page-module__content","grid":"components-hotel-account-selection-page-module__grid"};